<template>
  <slot />
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
  }
}
</script>
